import React from "react";
import { Link } from "react-router-dom";

import landscapeImage from "../assets/images/landscape-design.jpg";
import amcImage from "../assets/images/amc-maintenance.jpg";
// import kitchenGardenImage from "../assets/images/kitchen-gardening.jpg";
import swimmingPoolDesignImage from "../assets/images/swimming-pool-design.png";


const FeaturedServices = () => {
  const services = [
    {
      id: 1,
      title: "Landscape Design",
      description:
        "Transform your outdoor space with creative landscape design, beautiful planting, and professionally planned gardens.",
      image: landscapeImage,
      url: "/landscape-design-dubai",
    },

    {
      id: 2,
      title: "Annual Maintenance Contract",
      description:
        "Keep your garden healthy and beautiful throughout the year with our professional annual garden maintenance services.",
      image: amcImage,
      url: "/amc-packages-dubai-annual-maintenance-contract",
    },

    {
      id: 3,
      title: "Swimming Pool Design",
      description:
        "Create a beautiful and relaxing outdoor space with our professionally designed swimming pool solutions tailored to your property and lifestyle.",
      image: swimmingPoolDesignImage,
      url: "/swimming-pool-design-dubai",
    },



    // {
    //   id: 3,
    //   title: "Kitchen Gardening",
    //   description:
    //     "Grow fresh herbs, vegetables, and plants at home with our practical and professionally designed kitchen gardening solutions.",
    //   image: kitchenGardenImage,
    //   url: "/kitchen-gardening-dubai",
    // },
  ];

  return (
    <section className="featured-services-section">

      <div className="container">

        {/* Heading */}

        <div className="featured-services-heading text-center">

          <span>OUR SERVICES</span>

          <h2>
            Professional Gardening & Landscaping Solutions
          </h2>

          <p>
            From beautiful landscape design to complete garden maintenance
            and kitchen gardening, we create outdoor spaces that are healthy,
            beautiful, and easy to maintain.
          </p>

        </div>


        {/* Three Main Services */}

        <div className="row featured-services-row">

          {services.map((service) => (

            <div
              className="col-lg-4 col-md-6 col-12"
              key={service.id}
            >

              <div className="featured-service-card">

                {/* Image */}

                <div className="featured-service-image">

                  <img
                    src={service.image}
                    alt={service.title}
                  />

                  {/* Text Over Image */}

                  <div className="featured-service-overlay">

                    <h3>
                      {service.title}
                    </h3>

                  </div>

                </div>


                {/* Content */}

                <div className="featured-service-content">

                  <p>
                    {service.description}
                  </p>

                  <Link
                    to={service.url}
                    className="featured-service-btn"
                  >
                    VIEW DETAILS
                    <i className="icon-long-arrow-right"></i>
                  </Link>

                </div>

              </div>

            </div>

          ))}

        </div>

      </div>


      <style>
        {`

        .featured-services-section {
          padding: 90px 20px;
          background: #fff;
        }

        .featured-services-heading {
          max-width: 800px;
          margin: 0 auto 50px;
        }

        .featured-services-heading span {
          display: inline-block;
          margin-bottom: 10px;

          color: #4c8b3c;

          font-size: 13px;
          font-weight: 700;

          letter-spacing: 3px;
        }

        .featured-services-heading h2 {
          margin: 0 0 15px;

          color: #222;

          font-size: 40px;
          font-weight: 700;
          line-height: 1.2;
        }

        .featured-services-heading p {
          margin: 0;

          color: #777;

          font-size: 15px;
          line-height: 1.8;
        }


        .featured-services-row {
          row-gap: 30px;
        }


        .featured-service-card {
          height: 100%;

          overflow: hidden;

          background: #fff;

          border-radius: 12px;

          box-shadow:
            0 8px 30px rgba(0, 0, 0, 0.08);

          transition:
            all 0.35s ease;
        }

        .featured-service-card:hover {
          transform: translateY(-8px);

          box-shadow:
            0 18px 45px rgba(0, 0, 0, 0.14);
        }


        .featured-service-image {
          position: relative;

          width: 100%;
          height: 320px;

          overflow: hidden;
        }

        .featured-service-image img {
          width: 100%;
          height: 100%;

          object-fit: cover;

          display: block;

          transition:
            transform 0.6s ease;
        }

        .featured-service-card:hover
        .featured-service-image img {
          transform: scale(1.08);
        }


        .featured-service-overlay {
          position: absolute;

          left: 0;
          right: 0;
          bottom: 0;

          padding: 70px 25px 25px;

          background:
            linear-gradient(
              to top,
              rgba(0,0,0,0.75),
              rgba(0,0,0,0)
            );
        }

        .featured-service-overlay h3 {
          margin: 0;

          color: #fff;

          font-size: 27px;
          font-weight: 700;
        }


        .featured-service-content {
          padding: 25px;
        }

        .featured-service-content p {
          min-height: 75px;

          margin: 0 0 20px;

          color: #666;

          font-size: 14px;

          line-height: 1.7;
        }


        .featured-service-btn {
          display: inline-flex;

          align-items: center;

          gap: 10px;

          padding: 11px 20px;

          color: #fff;

          background: #4c8b3c;

          border-radius: 4px;

          font-size: 12px;

          font-weight: 700;

          letter-spacing: .5px;

          text-decoration: none;

          transition: all .3s ease;
        }

        .featured-service-btn:hover {
          color: #fff;

          background: #35652b;

          text-decoration: none;

          transform: translateX(3px);
        }


        @media (max-width: 767px) {

          .featured-services-section {
            padding: 60px 15px;
          }

          .featured-services-heading h2 {
            font-size: 30px;
          }

          .featured-service-image {
            height: 280px;
          }

        }

        `}
      </style>

    </section>
  );
};

export default FeaturedServices;
